import React from 'react';
import './TransactionTable.css';

interface Transaction {
  id: string;
  orderId: string;
  customer: string;
  amount: string;
  fee: string;
  net: string;
  method: string;
  status: 'completed' | 'pending' | 'failed' | 'refunded';
  dateTime: string;
}

interface TransactionTableProps {
  transactions: Transaction[];
  selectedTransactions: string[];
  onSelectTransaction: (transactionId: string) => void;
  onSelectAll: () => void;
}

const TransactionTable: React.FC<TransactionTableProps> = ({
  transactions,
  selectedTransactions,
  onSelectTransaction,
  onSelectAll,
}) => {
  const allSelected = selectedTransactions.length === transactions.length && transactions.length > 0;

  const getStatusClass = (status: string) => {
    return status.toLowerCase();
  };

  return (
    <div className="transaction-table-container">
      <table className="transaction-table">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                checked={allSelected}
                onChange={onSelectAll}
                className="table-checkbox"
              />
            </th>
            <th>Transaction ID</th>
            <th>Order ID</th>
            <th>Customer</th>
            <th>Amount</th>
            <th>Fee</th>
            <th>Net</th>
            <th>Method</th>
            <th>Status</th>
            <th>Date & Time</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((transaction) => (
            <tr 
              key={transaction.id}
              className={transaction.status === 'failed' ? 'transaction-failed-row' : ''}
            >
              <td>
                <input
                  type="checkbox"
                  checked={selectedTransactions.includes(transaction.id)}
                  onChange={() => onSelectTransaction(transaction.id)}
                  className="table-checkbox"
                />
              </td>
              <td className="transaction-id">{transaction.id}</td>
              <td className="transaction-order-id">{transaction.orderId}</td>
              <td className="transaction-customer">{transaction.customer}</td>
              <td className="transaction-amount">{transaction.amount}</td>
              <td className="transaction-fee">{transaction.fee}</td>
              <td className="transaction-net">{transaction.net}</td>
              <td className="transaction-method">{transaction.method}</td>
              <td>
                <span className={`transaction-status status-${getStatusClass(transaction.status)}`}>
                  {transaction.status}
                </span>
              </td>
              <td className="transaction-datetime">{transaction.dateTime}</td>
              <td>
                <button className="transaction-actions-btn">⋯</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TransactionTable;

